import "../App.css";
import { Slide, ToastContainer } from "react-toastify";

function AppLayout({ children }: any) {
    return (
        <>
            <div className={`flex flex-column`}>
                <ToastContainer
                    position="bottom-right"
                    autoClose={5000}
                    hideProgressBar={true}
                    newestOnTop={true}
                    closeOnClick
                    pauseOnHover
                    theme="colored"
                    transition={Slide}
                />
                {children}
            </div>
            <div id="adobe-dc-view"></div>
        </>
    );
}
export default AppLayout;
